import { useTranslation } from 'next-i18next'

import SVGImage from '~/components/Image/SVGImage'

interface Props {
  run: string
  score: number
  bestStreak: number
  level: number
}

export default function RunDetails({ run, score, bestStreak, level }: Props): React.ReactElement {
  const { t } = useTranslation('statistics')

  return (
    <div className="w-full font-semibold rounded overflow-hidden shadow-card space-y-3 pb-3 pt-2 mb-3 px-4 lg:px-20">
      <div className="flex justify-center items-center">
        <SVGImage alt="rainbow" className="mr-2" srcKey="scoreboard/rainbow.svg" />
        <p className="font-semibold text-purple">
          {t('windSurfer.run')}: {run || 0}
        </p>
      </div>
      <div className="flex justify-between items-center my-2">
        <p className="font-semibold">{t('windSurfer.score')}</p>
        <p className="font-semibold">{score || 0}</p>
      </div>
      <div className="flex justify-between items-center my-2">
        <p className="font-semibold">{t('windSurfer.bestStreak')}</p>
        <p className="font-semibold">{bestStreak || 0}</p>
      </div>
      <div className="flex justify-between items-center my-2">
        <p className="font-semibold">{t('level')}</p>
        <p className="font-semibold">{level || 0}</p>
      </div>
    </div>
  )
}
